export { default } from "bullitttime-embermodelsevent/adapters/class";
